import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const createBooking = (payload) =>
  axios.post(`${API}/bookings`, payload).then((r) => r.data);

export const getBooking = (ref) =>
  axios.get(`${API}/bookings/${ref}`).then((r) => r.data);

export const adminLogin = (password) =>
  axios.post(`${API}/admin/login`, { password }).then((r) => r.data);

export const adminList = (token, status = "all") =>
  axios
    .get(`${API}/admin/bookings?status=${status}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((r) => r.data);

export const adminUpdate = (token, ref, status) =>
  axios
    .patch(`${API}/admin/bookings/${ref}`, { status }, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((r) => r.data);

export const adminStats = (token) =>
  axios
    .get(`${API}/admin/stats`, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);

export const adminCreateInvoice = (token, payload) =>
  axios
    .post(`${API}/admin/invoices`, payload, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);

export const adminInvoices = (token) =>
  axios
    .get(`${API}/admin/invoices`, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);

export const adminSetInvoiceStatus = (token, ref, status) =>
  axios
    .patch(`${API}/admin/invoices/${ref}`, { status }, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);

export const getInvoice = (ref) =>
  axios.get(`${API}/invoices/${ref}`).then((r) => r.data);

export const adminSchedule = (token) =>
  axios
    .get(`${API}/admin/schedule`, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);

export const adminUpload = (token, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios
    .post(`${API}/admin/upload`, fd, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

export const adminCreateJob = (token, payload) =>
  axios
    .post(`${API}/admin/jobs`, payload, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);

export const adminJobStatus = (token, ref, status) =>
  axios
    .patch(`${API}/admin/jobs/${ref}`, { status }, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);
